import { eq, flow, option, tagged } from '@code-expert/prelude';
import type { QuestionId } from '/imports/modules/Quizzes/domain';
import { questionIdEq } from '/imports/modules/Quizzes/domain';

export type QuizNavSelection =
  | tagged.Tagged<'quiz'>
  | tagged.Tagged<'question', QuestionId>
  | tagged.Tagged<'summary'>;

export const quizNavSelectionAdt = tagged.build<QuizNavSelection>();

export const quizNavSelectionPrisms = tagged.prisms<QuizNavSelection>();

export const getSelectedQuestionId = flow(
  quizNavSelectionPrisms.question.getOption,
  option.map(tagged.value),
);

export const isSelectedQuestionId = (questionId: QuestionId) =>
  flow(getSelectedQuestionId, option.exists(eq.isEqualTo(questionIdEq)(questionId)));
